<template>
  <div>
    <b-modal
      ref="Ref-2fa-Modal"
      title="2FA Authentication"
      id="2fa-Modal"
      :no-enforce-focus="true"
      hide-footer
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-backdrop
    >
      <div
        style="
          padding: 1rem;
          border-bottom: 1px solid #dee2e6;
          font-size: 20px;
          font-weight: bold;
          margin: 0 -15px;
        "
      >
        {{ onlyAuthenticator ? "Authenticator Login" : "2FA Authentication" }}
      </div>
      <div class="pt-3">
        <button
          class="btn-modal-close"
          style="top: 15px; right: 15px; position: absolute; z-index: 99"
          @click="ClearData()"
        >
          &times;
        </button>
        <form @submit.prevent.stop="onConfirm()">
          <div class="modal-login-box">
            <div class="row">
              <div class="col-md-12 my-4">
                <div class="input-material">
                  <input
                    v-model="secretCode"
                    name="secretcode"
                    id="secretcode"
                    type="text"
                    class="pr-5"
                    placeholder="."
                    @keypress="isNumber($event)"
                    v-validate="'required|numeric|min:6|max:6'"
                  />
                  <label>{{ $t("secretcode") }}</label>
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('secretcode')">{{
                    errors.first("secretcode")
                  }}</span>
                </p>
                <div class="text-center mt-3">
                  <button type="submit" class="btn-blue w-50">
                    <span>{{ $t("confirm") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    openModal: Boolean,
    token: Number,
    onClickHandler: {
      type: Function
    },
    onClose: Boolean,
    onlyAuthenticator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      secretCode: "",
      submitted: false
    };
  },
  watch: {
    openModal(newVal) {
      if (newVal) {
        this.$refs["Ref-2fa-Modal"].show();
      } else {
        this.secretCode = "";
        this.$refs["Ref-2fa-Modal"].hide();
      }
    }
  },
  methods: {
    ClearData: function() {
      this.$emit("onClose", false);
    },
    isNumber: function(value) {
      if (value.keyCode < 48 || value.keyCode > 57) {
        value.preventDefault();
      }
    },
    onConfirm: function() {
      this.submitted = true;
      if(this.secretCode && String(this.secretCode).length == 6) {
        this.$emit("onConfirm", this.secretCode);
      }
      // this.$validator.validate().then(valid => {
      //   console.log('valid', valid);
      //   if (valid) {
          
      //   }
      // });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Partials/2FAModal.vue